import React from 'react'
import TabPreferences from './TabPreferences'

export const defaultUserPreferences = {
    dashboard:{tabs:[],rowsPerPage:10}
}

export const UserPreferencesContext = React.createContext({userPreferences: defaultUserPreferences, setUserPreferences: (values)=>{}});
